import * as betgalaxy from './BetCard.styles.betgalaxy';
import * as betprofessor from './BetCard.styles.betprofessor';
import * as betroyale from './BetCard.styles.betroyale';
import * as puntcity from './BetCard.styles.puntcity';
import * as puntgenie from './BetCard.styles.puntgenie';
import * as questbet from './BetCard.styles.questbet';
import * as sterlingparker from './BetCard.styles.sterlingparker';
import * as vikingbet from './BetCard.styles.vikingbet';
import * as volcanobet from './BetCard.styles.volcanobet';
import * as wellbet from './BetCard.styles.wellbet';
import * as juicybet from './BetCard.styles.juicybet';
import * as goldenrush from './BetCard.styles.goldenrush';
import * as forsport from './BetCard.styles.forsport';
import * as fiestabet from './BetCard.styles.fiestabet';
import * as junglebet from './BetCard.styles.junglebet';
import * as oldgill from './BetCard.styles.oldgill';
import * as sugarcastle from './BetCard.styles.sugarcastle';
import * as buffalobet from './BetCard.styles.buffalobet';
import * as titanbet from './BetCard.styles.titanbet';
import * as templebet from './BetCard.styles.templebet';
import * as slambet from './BetCard.styles.slambet';
import * as gigabet from './BetCard.styles.gigabet';
import * as betstride from './BetCard.styles.betstride';
import * as goldenbet888 from './BetCard.styles.goldenbet888';
import * as hyperbet from './BetCard.styles.hyperbet';
import * as bet777 from './BetCard.styles.bet777';
import * as chromabet from './BetCard.styles.chromabet';
import * as bet575 from './BetCard.styles.bet575';
import * as epicodds from './BetCard.styles.epicodds';
import * as pyramidbet from './BetCard.styles.pyramidbet';
import * as magnumbet from './BetCard.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  fiestabet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  templebet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
